var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTajhotel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100.8 94.2",
    style: {
      enableBackground: "new 0 0 100.8 94.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n  .st0{fill:#8C734C;}\n ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82,12.8l3.2-1.9V0L72.7,7.3 M84,3.7v6.8l-2.9-5.1L84,3.7z M82.3,11.5l-5.8-3.4l2.9-1.7L82.3,11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81,14.5l-9.3-5.4v14.7l9.3-5.4 M74.2,12l5.8,3.4h-5.8V12z M74.2,20.8v-3.4H80L74.2,20.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.2,21.9v10.9l12.6-7.3L90.5,20 M88.5,29.1v-6.8l2.9,5.1L88.5,29.1z M93.1,26.4l-2.9-5.1l5.8,3.4L93.1,26.4z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.5,14.5v3.8l9.3,5.4V9.1 M98.2,20.8l-5.8-3.4h5.8V20.8z M98.2,15.4h-5.8l5.8-3.4V15.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M99.8,7.3L87.2,0v10.9l3.2,1.9 M88.5,3.7l2.9,1.7l-2.9,5.1V3.7z M93.1,6.4L96,8.1l-5.8,3.4L93.1,6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M72.7,25.5l12.6,7.3V21.9L82,20 M84,29.1l-2.9-1.7l2.9-5.1V29.1z M79.4,26.4l-2.9-1.7l5.8-3.4L79.4,26.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.1,62.7c0,5.2,0,9.7-0.3,12.1c-0.2,1.6-0.5,2.9-1.7,3.1c-0.5,0.1-1.2,0.2-2,0.2c-0.7,0-0.9,0.2-0.9,0.5 c0,0.4,0.4,0.6,1.1,0.6c2.3,0,5.9-0.2,7.2-0.2c1.6,0,5.2,0.2,9,0.2c0.6,0,1.1-0.2,1.1-0.6c0-0.3-0.3-0.5-0.9-0.5 c-0.9,0-2.1-0.1-2.9-0.2c-1.7-0.2-2-1.5-2.2-3.1c-0.3-2.5-0.3-6.9-0.3-12.2V39.3l7.2,0.2c5.1,0.1,6.6,1.7,6.7,3.2l0.1,0.6 c0.1,0.9,0.2,1.1,0.6,1.1c0.3,0,0.5-0.3,0.5-0.9c0-1.5,0.2-5.4,0.2-6.6c0-0.9-0.1-1.2-0.5-1.2c-0.5,0-1.8,0.6-5.5,0.6H10 c-1.9,0-4-0.1-5.7-0.3c-1.4-0.1-2-0.7-2.5-0.7c-0.3,0-0.5,0.3-0.7,1.1C1.1,36.9,0,42.1,0,43c0,0.6,0.1,0.9,0.5,0.9 c0.3,0,0.5-0.2,0.6-0.7c0.1-0.5,0.4-1.1,1-2C3,40,4.3,39.7,7.6,39.6l8.5-0.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.3,64.4l0.5,0.4l4.5,12.1c0.3,0.7-0.1,1.2-0.5,1.3c-0.6,0.1-0.8,0.2-0.8,0.5c0,0.4,0.7,0.4,1.7,0.5 c4.5,0.1,8.5,0.1,10.5,0.1c2.1,0,2.6-0.1,2.6-0.6c0-0.4-0.3-0.5-0.7-0.5c-0.7,0-1.5-0.1-2.3-0.2c-1.2-0.3-2.8-1.1-4.9-6.2 c-3.6-8.7-12.5-31.9-13.8-35.1c-0.6-1.3-0.9-1.8-1.4-1.8c-0.6,0-0.9,0.6-1.6,2.3L39.1,73c-1.1,2.9-2.2,4.8-4.7,5.1 c-0.4,0.1-1.2,0.1-1.7,0.1c-0.4,0-0.7,0.1-0.7,0.5c0,0.5,0.3,0.6,1.1,0.6c2.9,0,6-0.2,6.6-0.2c1.7,0,4.1,0.2,5.9,0.2 c0.6,0,0.9-0.1,0.9-0.6c0-0.3-0.2-0.5-0.8-0.5h-0.8c-1.7,0-2.2-0.7-2.2-1.8c0-0.7,0.3-2,0.8-3.5l3-8.2c0.1-0.3,0.2-0.5,0.5-0.5  M48,61.5l-0.2-0.4l5.1-14l0.3-0.5l0.3,0.5l5,14.1l-0.3,0.3H48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.5,69.3c0,11.2,0.1,16.9-4.1,21.3c-1.1,1.1-1.9,1.8-2.6,2.2c-0.9,0.5-1.2,0.7-1.2,1l0.4,0.5 c0.3,0,0.7-0.1,1.1-0.3c1.1-0.6,2-1,2.7-1.5c5.2-3.4,8.1-7.3,9.3-10.8c1.1-3.2,1.3-6.9,1.3-10.1c0-2.8-0.2-5.6-0.2-8V52.9 c0-8.7,0-10.3,0.1-12.1c0.1-2,0.5-3,2-3.2c0.7-0.1,1-0.2,1.6-0.2c0.7,0,1-0.1,1-0.5c0-0.4-0.4-0.5-1.2-0.5c-2.1,0-5.6,0.2-6.9,0.2 c-1.4,0-4.9-0.2-7.7-0.2c-0.8,0-1.2,0.1-1.2,0.5c0,0.4,0.3,0.5,0.9,0.5c0.8,0,1.7,0.1,2.1,0.2c1.8,0.4,2.2,1.3,2.3,3.2 c0.1,1.8,0.1,3.4,0.1,12.1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTajhotel);
export default __webpack_public_path__ + "static/media/taj hotel.1f28fb918c41db431379bac06afcde95.svg";
export { ForwardRef as ReactComponent };